export default __webpack_public_path__ + "static/media/playButton.bacb370b.svg";